import React from "react";
import useAddIdsToUrl from "../../../utils/hooks/addIdsToUrl";
import useFacilityIds from "../../../utils/hooks/useFacilityIds";
import "./style.scss";
import NavBar from "../../../features/NavBar";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import RoutesComponent from "../Routes";
import useShowNavBar from "./useShowNavBar";
import Footer from "../../../features/Footer";

const HorizontalView: React.FC = () => {
  useFacilityIds();
  useAddIdsToUrl();
  const isDesktop = useDesktopSize();
  const showNavBar = useShowNavBar();

  return (
    <React.Fragment>
      <div className="background-shop">
        {/* {showNavBar && <NavBar />} */}
        <div
          className="saleContainer"
          style={isDesktop && showNavBar ? { marginLeft: "15%", width: "85%" } : { width: "100%" }}
        >
          <RoutesComponent />
          <Footer/>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HorizontalView;
